export const normalizeApostrophes = (val: string = ""): string =>
  val.replace(/[‘’‛]/g, "'").replace(/[“”]/g, '"');